import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { Phone, Mail, MapPin, Instagram, Facebook } from "lucide-react";

export const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer id="contact" data-testid="footer" className="border-t border-white/10 bg-black">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-1">
          <span className="font-serif text-2xl text-white">Autobus Limo</span>
          <p className="text-[10px] tracking-luxe uppercase text-muted-foreground mt-1">Mont Royal</p>
          <p className="text-muted-foreground text-sm mt-6 leading-relaxed">
            {t("footer.tagline")}
          </p>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-luxe text-muted-foreground mb-5">{t("footer.services")}</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li><Link to="/book?service=limousine" className="hover:text-white transition-colors">{t("svc.limousine.title")}</Link></li>
            <li><Link to="/book?service=party_bus" className="hover:text-white transition-colors">{t("svc.party_bus.title")}</Link></li>
            <li><Link to="/book?service=private_driver" className="hover:text-white transition-colors">{t("svc.private_driver.title")}</Link></li>
            <li><Link to="/airport-transfers" className="hover:text-white transition-colors">{t("footer.airport")}</Link></li>
            <li><Link to="/corporate" className="hover:text-white transition-colors">{t("nav.corporate")}</Link></li>
            <li><Link to="/weddings-events" className="hover:text-white transition-colors">{t("nav.weddings")}</Link></li>
            <li><Link to="/group-transportation" className="hover:text-white transition-colors">{t("nav.groups")}</Link></li>
            <li><Link to="/service-areas" className="hover:text-white transition-colors">{t("nav.areas")}</Link></li>
            <li><Link to="/portal" className="hover:text-white transition-colors">{t("nav.manageBooking")}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-luxe text-muted-foreground mb-5">{t("footer.company")}</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li><Link to="/book" className="hover:text-white transition-colors">{t("footer.reserve")}</Link></li>
            <li><Link to="/login" className="hover:text-white transition-colors">{t("footer.signin")}</Link></li>
            <li><a href="#fleet" className="hover:text-white transition-colors">{t("footer.ourFleet")}</a></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-luxe text-muted-foreground mb-5">{t("footer.contact")}</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li className="flex items-center gap-3"><Phone className="h-4 w-4" /> <a href="tel:+14384701138" className="hover:text-white transition-colors" data-testid="footer-phone">438-470-1138</a></li>
            <li className="flex items-center gap-3"><Mail className="h-4 w-4" /> autobuslimo@autobusmr.com</li>
            <li className="flex items-center gap-3"><MapPin className="h-4 w-4" /> Mont Royal, Montréal QC</li>
          </ul>
          <div className="flex gap-4 mt-6">
            <a href="#" className="text-white/60 hover:text-white transition-colors"><Instagram className="h-5 w-5" /></a>
            <a href="#" className="text-white/60 hover:text-white transition-colors"><Facebook className="h-5 w-5" /></a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-6">
        <p className="text-[10px] uppercase tracking-luxe text-muted-foreground mb-3 text-center">{t("footer.popular")}</p>
        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-white/55">
          <Link to="/services/montreal-limousine-service" className="hover:text-white transition-colors">Montréal Limousine</Link>
          <Link to="/services/montreal-private-chauffeur" className="hover:text-white transition-colors">Private Chauffeur</Link>
          <Link to="/services/montreal-ford-sprinter" className="hover:text-white transition-colors">Ford Sprinter</Link>
          <Link to="/services/montreal-charter-bus-rental" className="hover:text-white transition-colors">Charter Bus Rental</Link>
          <Link to="/services/montreal-to-quebec-city" className="hover:text-white transition-colors">Montréal → Québec</Link>
          <Link to="/services/montreal-to-ottawa" className="hover:text-white transition-colors">Montréal → Ottawa</Link>
          <Link to="/services/montreal-to-toronto" className="hover:text-white transition-colors">Montréal → Toronto</Link>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 flex flex-col sm:flex-row items-center justify-center gap-2 text-center text-xs text-muted-foreground">
        <span>© {new Date().getFullYear()} Autobus Limo Mont Royal. {t("footer.rights")}</span>
        <span className="hidden sm:inline">·</span>
        <Link to="/admin-login" data-testid="footer-admin-link" className="hover:text-white transition-colors">{t("footer.admin")}</Link>
      </div>
    </footer>
  );
};
